<template>
    <v-text-field
        type="date"
        :model-value="currentValue"
        @update:model-value="onChange"
        label=""
        variant="outlined"
        density="compact"
        hide-details
    ></v-text-field>
</template>

<script>
export default {
    name: "AppDatePicker",
    props: {
        modelValue: {
            required: false
        },
        value: {
            required: false
        },
        allowedDates: {
            type: Function
        }
    },
    emits: ['update:modelValue', 'input'],
    computed: {
        currentValue() {
            return this.modelValue !== undefined ? this.modelValue : this.value;
        }
    },
    methods: {
        onChange(value) {
            this.$emit('update:modelValue', value || null);
            this.$emit('input', value || null);
        }
    }
}
</script>

<style scoped>
</style>
